"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchDarklyProvider = void 0;
exports.useLaunchDarklyData = useLaunchDarklyData;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const Context = (0, react_1.createContext)();
const LaunchDarklyProvider = ({ children, contextData }) => {
    return ((0, jsx_runtime_1.jsx)(Context.Provider, { value: contextData, children: children }));
};
exports.LaunchDarklyProvider = LaunchDarklyProvider;
function useLaunchDarklyData() {
    const data = (0, react_1.useContext)(Context);
    if (typeof data === 'undefined') {
        throw new Error('useLaunchDarklyData must be used within LaunchDarklyProvider');
    }
    return data;
}
// add display name for dev tool readability 
Context.displayName = 'LaunchDarkly';
LaunchDarklyProvider.displayName = 'LaunchDarklyContext';
LaunchDarklyProvider.propTypes = {
    children: prop_types_1.default.object,
    contextData: prop_types_1.default.object
};
//# sourceMappingURL=context.js.map